import React from 'react';
import styled from 'styled-components';

interface VideoBackgroundProps {
    videoSrc: string;
    posterImage?: string;
    children: React.ReactNode;
    overlayOpacity?: number;
}

const VideoContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 20;
`;

const StyledVideo = styled.video`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;

    @media (prefers-reduced-motion: reduce) {
        display: none;
    }
`;

const Overlay = styled.div<{ $opacity: number }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        to bottom,
        rgba(26, 29, 41, ${({ $opacity }) => $opacity * 0.75}),
        rgba(26, 29, 41, ${({ $opacity }) => $opacity * 0.85})
    );
    z-index: 1;
`;

const Content = styled.div`
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const VideoBackground: React.FC<VideoBackgroundProps> = ({
    videoSrc,
    posterImage,
    children,
    overlayOpacity = 0.5,
}) => {
    return (
        <VideoContainer>
            <StyledVideo autoPlay muted loop playsInline preload="metadata" poster={posterImage}>
                <source src={videoSrc} type="video/mp4" />
            </StyledVideo>
            <Overlay $opacity={overlayOpacity} />
            <Content>{children}</Content>
        </VideoContainer>
    );
};
